import './modalContent.css'

export default function Guitar() {
  return (
    <div className='modal-content'>
      <h2 className='modal-header'>My Life in Music: A Symphony of Strings and Beats</h2>
      <div className='modal-body'>
        <p>
          Music has been a constant companion in my life, a journey that began at the tender age of 13. It was then that
          my dad introduced me to the world of guitar, teaching me the basic chords and the mystical pentatonic scale.
          Those early days, filled with strumming and learning, laid the foundation for what would become a lifelong
          passion.
        </p>

        <h3>🎸 The Guitar Years: Self-Taught and Stage-Ready</h3>
        <p>
          My adventure with the guitar didn't stop at basic chords. Over the years, I've taught myself to write songs,
          advance my techniques, and explore the vast landscapes of music. My guitar became not just an instrument, but
          a voice, expressing my innermost emotions and stories through melodies and rhythms.
        </p>
        <p>
          I've had the privilege of sharing this musical journey with others, playing around town with local acts. We
          showcased original music, each performance a testament to our creativity and collaboration. These experiences
          weren't just about playing music; they were about connecting with people, sharing moments of joy, and creating
          memories.
        </p>

        <h3>🥁 From Strings to Sticks: My Drumming Path</h3>
        <p>
          In 2020, I embarked on a new musical chapter – the world of drums. This rhythm-filled journey brought a new
          perspective to my understanding of music. Building my own electronic drum set, with the help of my trusty 3D
          printer, was not only a DIY challenge but a fusion of my technical skills and musical interests.
        </p>

        <p>
          Today, my focus has shifted mostly to the drums, exploring the pulse and heartbeat of music. I'm honing my
          skills with the sticks and plan to start playing locally again soon. This next phase is not just about
          performing but continuing the story of my musical evolution.
        </p>

        <p>
          As you explore Tim's Planet, you'll encounter echoes of my musical life, a blend of the old and the new. It's
          a life where every note played and every rhythm struck tells a part of my story. Thanks for being a part of
          this melodious journey!
        </p>
      </div>
    </div>
  )
}
